import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IconComponent } from '~app/shared/components/icon/icon.component';
import { AutoExpandDirective } from '~app/shared/directives/auto-expand/auto-expand.directive';
import { ClickOutsideDirective } from '~app/shared/directives/clickOutside/click-outside.directive';
import { TooltipDirective } from '~app/shared/directives/tooltip/tooltip.directive';
import { SafePipe } from '~app/shared/pipes/safe/safe.pipe';
import { CountryListResolver } from '~app/shared/resolvers/countryList.resolver';
import { PortCodeMasterResolver } from '~app/shared/resolvers/portCodeMaster.resolver';
import { AccordionItemComponent } from './components/accordion-item/accordion-item.component';
import { ButtonComponent } from './components/button/button.component';
import { CollectionItemComponent } from './components/collection-item/collection-item.component';
import { ContentComponent } from './components/content/content.component';
import { DocumentManagerModalComponent } from './components/document-manager-modal/document-manager-modal.component';
import { DocusignComponent } from './components/docusign/docusign.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { ErrorListComponent } from './components/error-list/error-list.component';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { EyeButtonComponent } from './components/eye-button/eye-button.component';
import { InputCheckboxComponent } from './components/input-checkbox/input-checkbox.component';
import { InputCheckboxgroupComponent } from './components/input-checkboxgroup/input-checkboxgroup.component';
import { InputDropdownComponent } from './components/input-dropdown/input-dropdown.component';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { InputRadioComponent } from './components/input-radio/input-radio.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { LinkComponent } from './components/link/link.component';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';
import { RateExperienceModalComponent } from './components/rate-experience-modal/rate-experience-modal.component';
import { SectionComponent } from './components/section/section.component';
import { ShareFooterComponent } from './components/share-footer/share-footer.component';
import { SharedHeaderComponent } from './components/shared-header/shared-header.component';
import { SoeaModalComponent } from './components/soea-modal/soea-modal.component';
import { SoeaViewerComponent } from './components/soea-viewer/soea-viewer.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SuccessModalComponent } from './components/success-modal/success-modal.component';
import { SummaryModalComponent } from './components/summary-modal/summary-modal.component';
import { TextComponent } from './components/text/text.component';
import { TitleComponent } from './components/title/title.component';
import { TooltipContainerComponent } from './components/tooltip-container/tooltip-container.component';
import { UpdateInfoCardComponent } from './components/update-info-card/update-info-card.component';
import { FeatureFlagDirective } from './directives/feature-flag/feature-flag.directive';
import { PopoverDirective } from './directives/popover/popover.directive';
import { ReactiveInputDirective } from './directives/reactive-input/reactive-input.directive';
import { FirstAndLastCapPipe } from './pipes/firstAndLastCap/first-and-last-cap.pipe';
import { ProfileResolver } from './resolvers/profile.resolver';
import { ShipListResolver } from './resolvers/shipList.resolver';
import { DateFromMWPipe } from './pipes/date-from-mw.pipe';
import { CardComponent } from './components/card/card.component';
import { PopoverComponent } from './components/popover/popover.component';
import { VaccinesTableComponent } from './components/vaccines-table/vaccines-table.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { InputSingleCheckboxComponent } from './components/input-single-checkbox/input-single-checkbox.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, OverlayModule, CdkAccordionModule],
  declarations: [
    SharedHeaderComponent,
    ShareFooterComponent,
    UpdateInfoCardComponent,
    TooltipDirective,
    TooltipContainerComponent,
    SafePipe,
    ModalContainerComponent,
    ErrorModalComponent,
    SuccessModalComponent,
    ClickOutsideDirective,
    FeatureFlagDirective,
    SpinnerComponent,
    DocusignComponent,
    FirstAndLastCapPipe,
    DropdownComponent,
    SoeaModalComponent,
    // IconComponent,
    ReactiveInputDirective,
    InputTextComponent,
    InputCheckboxComponent,
    ErrorListComponent,
    InputDropdownComponent,
    EyeButtonComponent,
    DocumentManagerModalComponent,
    AccordionItemComponent,
    CollectionItemComponent,
    SummaryModalComponent,
    RateExperienceModalComponent,
    InputRadioComponent,
    InputNumberComponent,
    InputCheckboxgroupComponent,
    SoeaViewerComponent,
    TextComponent,
    ButtonComponent,
    TitleComponent,
    ContentComponent,
    SectionComponent,
    LinkComponent,
    IconComponent,
    AutoExpandDirective,
    PopoverDirective,
    DateFromMWPipe,
    CardComponent,
    PopoverComponent,
    VaccinesTableComponent,
    CalendarComponent,
    AccordionComponent,
    InputSingleCheckboxComponent,
  ],
  exports: [
    SharedHeaderComponent,
    ShareFooterComponent,
    UpdateInfoCardComponent,
    TooltipDirective,
    TooltipContainerComponent,
    SafePipe,
    ModalContainerComponent,
    ErrorModalComponent,
    SummaryModalComponent,
    SuccessModalComponent,
    ClickOutsideDirective,
    FeatureFlagDirective,
    SpinnerComponent,
    DocusignComponent,
    FirstAndLastCapPipe,
    DropdownComponent,
    SoeaModalComponent,
    RateExperienceModalComponent,
    // IconComponent,
    ReactiveInputDirective,
    InputTextComponent,
    InputSingleCheckboxComponent,
    InputCheckboxComponent,
    InputCheckboxgroupComponent,
    InputRadioComponent,
    ErrorListComponent,
    InputDropdownComponent,
    EyeButtonComponent,
    DocumentManagerModalComponent,
    AccordionItemComponent,
    CollectionItemComponent,
    InputNumberComponent,
    SoeaViewerComponent,
    TextComponent,
    ButtonComponent,
    TitleComponent,
    ContentComponent,
    SectionComponent,
    LinkComponent,
    IconComponent,
    AutoExpandDirective,
    PopoverDirective,
    DateFromMWPipe,
    CardComponent,
    PopoverComponent,
    VaccinesTableComponent,
    CalendarComponent,
    AccordionComponent,
  ],
  providers: [CountryListResolver, ShipListResolver, PortCodeMasterResolver, ProfileResolver],
})
export class SharedModule {}
